module.exports = __webpack_public_path__ + "img/example-dashboard.c51fe4ee.jpg";